import { useEffect } from "react";

export function useSeo(title, description) {
  useEffect(() => {
    document.title = title ? `${title} | Sido Holdings` : "Sido Holdings | Oregon Commercial Real Estate Acquisition";
    const meta = document.querySelector('meta[name="description"]');
    if (meta && description) meta.setAttribute("content", description);
    window.scrollTo(0, 0);
  }, [title, description]);
}
